module.exports = __webpack_public_path__ + "static/media/boyblack2-1-2000x1638.1f4c2a15.jpg";